module.exports = __webpack_public_path__ + "static/media/taylor-momsen-lesb.f81cce46.jpg";